import rootMessages from "@/client/locale/en-US/messages";

let messages = {};

export default utilities.mergeObjects(rootMessages, messages);
